var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablerTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7232 26.7912H43.8498M30.7232 35.5423H43.8498M30.7232 44.2934H43.8498M8.84546 11.4768C8.84546 10.8966 9.07596 10.3401 9.48624 9.92985C9.89653 9.51956 10.453 9.28906 11.0332 9.28906H41.6621C42.2423 9.28906 42.7988 9.51956 43.209 9.92985C43.6193 10.3401 43.8498 10.8966 43.8498 11.4768V15.8524C43.8498 16.4326 43.6193 16.9891 43.209 17.3994C42.7988 17.8097 42.2423 18.0402 41.6621 18.0402H11.0332C10.453 18.0402 9.89653 17.8097 9.48624 17.3994C9.07596 16.9891 8.84546 16.4326 8.84546 15.8524V11.4768ZM8.84546 28.979C8.84546 28.3988 9.07596 27.8423 9.48624 27.432C9.89653 27.0217 10.453 26.7912 11.0332 26.7912H19.7843C20.3646 26.7912 20.921 27.0217 21.3313 27.432C21.7416 27.8423 21.9721 28.3988 21.9721 28.979V42.1057C21.9721 42.6859 21.7416 43.2424 21.3313 43.6526C20.921 44.0629 20.3646 44.2934 19.7843 44.2934H11.0332C10.453 44.2934 9.89653 44.0629 9.48624 43.6526C9.07596 43.2424 8.84546 42.6859 8.84546 42.1057V28.979Z",
    stroke: "white",
    strokeWidth: 2.66733,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerTemplate);
export default __webpack_public_path__ + "static/media/tabler_template.134e44accd649a53a18a0887756c3d66.svg";
export { ForwardRef as ReactComponent };